import { ChevronRight, Container, Cpu, Github, Laptop, SquareTerminal, Wrench } from "lucide-react";
import Reveal from "@/components/ui/Reveal";
import { DEV_ENV, TOOLBOX } from "@/data/portfolio";

const ICONS = { Laptop, SquareTerminal, ChevronRight, Github, Container };

const NEOFETCH = [
  "    ▄▄▄▄▄▄▄▄    ",
  "  ▄██████████▄  ",
  " ███      ███   ",
  " ███  ▄▄  ███   ",
  " ███      ███   ",
  "  ▀██████████▀  ",
  "    ▀▀▀▀▀▀▀▀    ",
];

const INFO = [
  "anish@portfolio",
  "───────────────",
  "host     MacBook Air M4",
  "os       macOS + Ubuntu Linux",
  "shell    zsh",
  "vcs      Git · GitHub",
  "ship     Docker · CI/CD",
  "code     Java 17 · React",
  "uptime   since Sep 2024",
];

export default function DevEnvWindow() {
  return (
    <div className="space-y-5 p-6 sm:p-7" data-testid="devenv-content">
      <div>
        <p className="eyebrow">neofetch — the workspace</p>
        <p className="mt-2 text-sm text-slate-400">The machine I think on, the shell I live in, the tools I ship with.</p>
      </div>

      <div className="overflow-hidden rounded-xl border border-white/8 bg-[#0d1117] p-4 font-mono text-[11px] sm:text-xs" data-testid="devenv-neofetch">
        {NEOFETCH.map((art, i) => (
          <p key={i} className="whitespace-pre">
            <span className="text-sonoma">{art}</span>
            <span className={i === 0 ? "ml-2 text-white" : i === 1 ? "ml-2 text-slate-500" : "ml-2 text-sky-300"}>{INFO[i] || ""}</span>
          </p>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="devenv-grid">
        {DEV_ENV.map((d, i) => {
          const Icon = ICONS[d.icon] || Cpu;
          return (
            <Reveal key={d.name} delay={i * 0.05} className="h-full">
              <div className="h-full rounded-xl border border-white/8 bg-white/[.03] p-4 transition-colors duration-200 hover:border-sonoma/30 hover:bg-white/[.05]">
                <Icon size={18} className="text-sky-300" />
                <p className="mt-2.5 font-display text-sm font-bold text-white">{d.name}</p>
                <p className="mt-0.5 font-mono text-[10.5px] text-slate-500">{d.detail}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <div>
        <p className="eyebrow mb-2">also in the toolbox</p>
        <div className="flex flex-wrap gap-2">
          {TOOLBOX.map((t) => (
            <span key={t} className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[.04] px-3 py-1.5 font-mono text-[11px] text-slate-400">
              <Wrench size={10} className="text-iris" /> {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
